if (!customElements.get('video-carousel')) {
    class VideoSwiper extends HTMLElement {
        mySwiper;
        constructor() {
            super();

        }
        connectedCallback() {
            this.style.display = "block"
            this.block_num = this.getAttribute('data-num') > 2 ? 3 : this.getAttribute('data-num')
            this.mySwiper = new Swiper(this.querySelector('.swiper_container'), {
                slidesPerView: this.block_num,
                slidesPerGroup: this.block_num,
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
                spaceBetween: 24,
                allowSlideNext: true,
                allowSlidePrev: true,
                breakpoints: {
                    989: {
                        slidesPerView: this.block_num,
                        slidesPerGroup: this.block_num,
                    },
                    750: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                    },
                    360: {
                        slidesPerView: 1.2,
                        slidesPerGroup: 1,
                    },
                },
                navigation: {
                    nextEl: this.querySelector(`.swiper_button_next`),
                    prevEl: this.querySelector(`.swiper_button_prev`),
                },
                pagination: {
                    el: this.querySelector(`.swiper-pagination`),
                    clickable: true,
                },
                on: {
                    slideChange: this.handleSlideChange.bind(this),
                },
                scrollbar: {
                    el: this.querySelector(`.swiper-scrollbar`),
                    draggable: true,
                },
            });
            this.initEvent(this.mySwiper);
        }

        /**
         * 轮播图切换事件
         */
        handleSlideChange(swiper) {

        }

        initEvent(swiper) {
        }

    }
    customElements.define('video-carousel', VideoSwiper);
}

